<template>
  <div
    :itemscope="useSchema"
    :itemtype="useSchema ? 'http://schema.org/ImageObject' : undefined"
    :class="[
      'p-card',
      'js-test-list-offer',
      'product-card',
      { skeleton: !model.id },
      { viewed },
    ]"
    :data-lazy="lazyImg && model.id ? model.id : null"
    :data-id="null"
    :data-rid="model && model.id"
  >
    <div
      ref="card"
      class="product-card__analytics"
      :data-slot="position"
      :data-url="objToBase64({ url: model.view_url })"
      :data-block="blockType"
      :data-type="'offer'"
      :data-offer_id="model.id ? model.id : ''"
      :data-rid="model && model.id"
    />
    <DebugInfo v-if="debugPanel" type="offer" :data="model" />

    <div class="product-card__wrapper">
      <div v-if="model.id" class="product-card__picture-section">
        <UiStickerMonitoring
          v-if="isPercent"
          class="product-card__marker product-card__offer-sticker"
          type="percent"
          :text="model.discount.percent"
        />
        <div class="product-card__slider">
          <ui-product-card-slider
            :model="model"
            :lazy-img="lazyImg"
            :index="index"
            :offers="offers"
            type="offer"
            block-type="list"
            :position="position"
            :model-path="modelPath"
            :use-schema="useSchema"
            :disabled="isPlaceOrder"
          />
        </div>
      </div>
      <div v-if="model.id" class="product-card__info-description">
        <div v-if="mediaMobile" class="offer-price">
          <Currency
            v-if="model"
            type="new"
            :value="ProductPrice"
            prefix=""
            class="product-card__price price-s"
          />
          <Currency
            v-if="isCurrency"
            class="product-card__price-old body-s-strikethrough"
            :value="model.discount.price_before"
          />
        </div>
        <cpc-link
          :to="model.click_url"
          :offer="model"
          :position="position"
          :block-type="blockType"
          class="product-card__title body-l-medium"
          :disabled="isPlaceOrder"
        >
          {{ modelName }}
        </cpc-link>
        <div
          v-if="model.description && !isBot"
          class="p-card__characteristic product-card__description"
          :itemprop="useSchema ? 'description' : undefined"
        >
          <span class="label body-m-regular">Описание от магазина: </span>
          <span class="value body-m-regular">{{ modelDescription }}</span>
        </div>
        <div
          v-if="showMoreButton"
          class="button-descriptions"
          @click="openModal"
        >
          <ui-ui-link
            size="medium"
            icon-before="info-circle"
            responsive-ico
            :font-weight="400"
          >
            Полное описание
          </ui-ui-link>
        </div>
        <UiDeliveryInfoCard
          v-if="model.id"
          class="delivery-mobile"
          :model="model"
          @open-info="openModal"
        />
        <div
          v-if="mediaMobile"
          class="product-card__buttons l-only-mobile"
          :class="{ 'l-mtop-8': showMoreButton }"
        >
          <cpc-link
            v-if="!isPlaceOrder"
            :to="model.click_url"
            :offer="model"
            :position="position"
            :block-type="blockType"
          >
            <ui-ui-button
              mode="div"
              type="outline"
              size="medium"
              font-class="body-m-regular"
              responsive-ico
              :resize="true"
              :loading="!model.id"
              icon-after="link-external"
            >
              В магазин
            </ui-ui-button>
          </cpc-link>
          <ui-ui-button
            v-else
            type="outline"
            :resize="true"
            size="medium"
            :loading="!model.id"
            @click="openOrderModal(blockType, position)"
          >
            Сделать заказ
          </ui-ui-button>
          <shop-rating :shop="model" />
        </div>
      </div>
      <div v-if="!mediaMobile && model.id" class="product-card__shop-section">
        <div v-if="!mediaMobile" class="offer-price">
          <Currency
            v-if="model"
            type="new"
            :value="ProductPrice"
            prefix=""
            class="product-card__price price-s"
          />
          <Currency
            v-if="isCurrency"
            class="product-card__price-old body-s-strikethrough"
            :value="model.discount.price_before"
          />
        </div>
        <div class="p-card__info-price">
          <cpc-link
            class="p-card__price-self-pickup text-body-s-book"
            :to="model.click_url"
            :offer="model"
            :position="position"
            :block-type="blockType"
            :disabled="isPlaceOrder"
          >
            <ui-delivery-info-b :model="model" is-card />
          </cpc-link>
        </div>
        <div
          v-if="!mediaMobile"
          class="product-card__buttons"
          :class="{ 'l-mtop-8': showMoreButton }"
        >
          <cpc-link
            v-if="!isPlaceOrder"
            :to="model.click_url"
            :offer="model"
            :position="position"
            :block-type="blockType"
          >
            <ui-ui-button
              mode="div"
              size="medium"
              :resize="true"
              type="outline"
              font-class="body-m-regular"
              responsive-ico
              :loading="!model.id"
              icon-after="link-external"
            >
              В магазин
            </ui-ui-button>
          </cpc-link>
          <ui-ui-button
            v-else
            :resize="true"
            size="medium"
            type="outline"
            :loading="!model.id"
            @click="openOrderModal(blockType, position)"
          >
            Сделать заказ
          </ui-ui-button>
        </div>
        <shop-rating :shop="model" class="price-card__basement offer" />
      </div>

      <template v-if="!model.id">
        <div class="p-card__slider">
          <div class="p-card__skeleton_img" />
        </div>
        <div class="p-card__info-description">
          <div class="p-card__title" />
        </div>
        <div class="p-card__characteristic">
          <div class="p-card__characteristic-text" />
        </div>
        <div class="p-card__price" />
        <div class="p-card__info-price">
          <p class="p-card__price-self-pickup" />
        </div>
      </template>
    </div>
    <QuickViewOffer
      v-if="showQuickViewOffer"
      :model="model"
      @close="showQuickViewOffer = false"
      @order="getOrder"
    />
  </div>
</template>
<script setup lang="ts">
import shopRating from '~/components/ui/storeRating/storeRatingNotModel.vue';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import cpcLink from '~/components/ui/CpcLink.vue';
import DebugInfo from '~/components/debug-info/DebugInfo.vue';
import Currency from '~/components/ui/currency/Currency.vue';
import { useAnalyticsStore } from '~/stores/analytics';
import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';
import { useTimeCalculation } from '~/composition/useTimeCalculation';
import { removeTags } from '~/utils/removeTags';
import { useModalsStore } from '~/stores/modals';
import { objToBase64 } from '~/utils/base64';

const QuickViewOffer = defineAsyncComponent(
  () => import('~/components/modals/quick-view-offer/quick-view-offer.vue')
);

const props = defineProps({
  model: {
    type: Object as () => any,
  },
  offers: Array,
  lazyImg: {
    type: Boolean,
    default: false,
  },
  nuxtLazy: {
    type: Boolean,
    default: false,
  },
  isBot: {
    type: Boolean,
    default: false,
  },
  viewed: {
    type: Boolean,
    default: false,
  },
  position: {
    type: Number,
    default: 1,
  },
  blockType: {
    type: String,
    default: 'listing',
  },
  useSchema: Boolean,
  addFilterQuery: {
    type: String,
    default: '',
  },
  showMoreButton: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Number,
    default: 0,
  },
  discountMax: {
    type: Number,
    default: 0,
  },
  shopRatingHighCount: {
    type: Number,
    default: 0,
  },
});

const card = ref<HTMLElement | undefined>();
const showButtonMoreOnDesktop = ref(false);
const showQuickViewOffer = ref<boolean>(false);
const { $ymAnyEvent } = useNuxtApp();
const storeMedia = useMediaQueryStore();
const analyticsStore = useAnalyticsStore();
const globalStore = useGlobalStore();
const interactiveStore = useInteractiveStore();
const modalsStore = useModalsStore();
const isFirstInteractive = computed(() => interactiveStore.isFirstInteractive);
const debugPanel = computed(() => globalStore.debugPanel);
const mediaMobile = computed(() => storeMedia.isMobile);
const modelName = computed(() => props.model?.name || '');
const isPlaceOrder = computed(() => props.model?.cpo);

const modelDescription = computed(() => removeTags(props.model.description));
const ProductPrice = computed(() => {
  if (props.model) {
    return props.model.price || props.model?.price_info?.min;
  }
  return '';
});

const isPercent = computed<boolean>(
  () =>
    !!props.model &&
    'discount' in props.model &&
    !!props.model.discount &&
    props.model.discount.percent > 0
);

const isCurrency = computed<boolean>(
  () =>
    !!props.model &&
    'discount' in props.model &&
    !!props.model.discount?.price_before
);

const modelPath = computed(() => {
  const model = props.model;
  if (!model) return '';
  const slug = model?.slug || '';
  if (!props.addFilterQuery) return `/${slug}/`;
  return `/${slug}/?${props.addFilterQuery}`;
});

const openModal = () => {
  if (props.model) {
    showQuickViewOffer.value = true;
  }
  $ymAnyEvent('reachGoal', 'click_na_opisanie_ot_magazina');
};
const openOrderModal = (blockType: string, position: number) => {
  modalsStore.setData({
    name: 'order',
    data: {
      offer: props.model,
      position,
      blockType,
    },
  });
};
const getOrder = () => {
  showQuickViewOffer.value = false;
  openOrderModal('pu-offer', 1);
};

onMounted(() => {
  if (card.value)
    nextTick(() => {
      if (card.value) {
        analyticsStore.observeView(card.value);
      }
      if (!props.isBot) {
        showButtonMoreOnDesktop.value = true;
      }
    });
});

onBeforeUnmount(() => {
  if (card.value) analyticsStore.unobserveView(card.value);
});
useTimeCalculation();
</script>
<style scoped lang="scss" src="./productCardListOfferScss.scss" />
